import { SVGIcon } from '@superops/super-icons';
import { ActionList, Button, Popover } from '@superops/ui-design-system';
import { getEntityIconMap } from '@nile/reports/src/modules/charts/utils/chart-transformation/ChartUtil';
import { getTranslatedText } from '@nile/components';
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

function EntitySelector(props) {
  const { data = [], loading, onChange, selectedValue } = props;

  const intl = useIntl();

  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive((active) => !active), []);

  const setValue = (ent) => {
    onChange(ent);
    toggleActive();
  };

  const entLabel =
    data.find((el) => el.name === selectedValue)?.label || 'common.choose';

  const activator = (
    <Button
      onClick={toggleActive}
      icon={
        <div className="mr8">
          <SVGIcon
            name={getEntityIconMap[selectedValue].iconName}
            color={`${getEntityIconMap[selectedValue].iconColor} !important`}
          />
        </div>
      }
      loading={loading}
      disclosure
      fullWidth
      textAlign="left"
    >
      <div className="ellipsis">{getTranslatedText(intl, entLabel)}</div>
    </Button>
  );

  return (
    <div className="w250 mb-15 entitiySelector">
      <Popover active={active} activator={activator} onClose={toggleActive}>
        <ActionList
          actionRole="menuitem"
          items={data.map((el) => ({
            content: getTranslatedText(intl, el.label),
            onAction: () => setValue(el),
            iconName: getEntityIconMap[el.name]?.iconName,
            iconColor: getEntityIconMap[el.name]?.iconColor
          }))}
        />
      </Popover>
    </div>
  );
}

export default EntitySelector;
